<template>
  <div v-loading="loading" class="app-container">
    <div>
      <label style="padding-right:10px">{{ $t('common.domain') }}</label>
      <el-select
        v-model="selectedDomainID"
        class="search-select"
        type="select"
        style="width: 20%; padding-bottom: 10px"
        :placeholder="$t('common.domain')"
      >
        <el-option v-for="domain in domains" :key="domain.id" :label="domain.name" :value="domain.id" />
      </el-select>
    </div>
    <editor-button
      :disabled="!selectedDomainID"
      button-translation="common.downloadExcel"
      action="primary"
      :icon-only="false"
      style="padding-bottom:10px;"
      @click="exportSelection()"
    />
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import { ForceFileDownload } from '@/utils/general';

export default {
  components: {
    EditorButton
  },
  data() {
    return {
      loading: false,
      selectedDomainID: this.$store.getters['domain/getDefaultSelectValueDomainID']
    };
  },
  computed: {
    domains() {
      return this.$store.getters.domains;
    }
  },
  methods: {
    exportSelection() {
      this.loading = true;
      this.$store
        .dispatch('report/fabricReport', { domainID: this.selectedDomainID })
        .then(blob => {
          ForceFileDownload(blob, 'Stofgegevens.xlsx');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
